import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaGlobe, FaMapMarkerAlt, FaIndustry } from 'react-icons/fa';
import './EmpresasLocales.css';

// Importar imágenes de empresas
import espanaImage from '../../Images/Espana/Logotipo Miguel España - Social Media.webp';
import devasImage from '../../Images/devas/frente t - Devas Gourmet.webp';
import lopezImage from '../../Images/HermanosLopez/Logo para lona - Hermanos Lopez Navarro.webp';
import soledadImage from '../../Images/soledad/soledad.webp';
import boradriImage from '../../Images/boradri/boradri.webp';
import delpicasImage from '../../Images/delpicas/delpicas.webp';
import nazarenoImage from '../../Images/nazareno/nazareno.webp';

const EmpresasLocales = () => {
  const empresas = [
    {
      id: 1,
      nombre: "Miguel España e hijos S.A.",
      sector: "Alimentario",
      descripcion: "Empresa especializada en la producción de embutidos y jamones, de gran calidad y elaborados de manera artesanal con más de 30 años de experiencia en el sector.",
      imagen: espanaImage,
      email: "info@espanahijos.com",
      telefono: "925 75 82 23",
      web: "www.espanahijos.com",
      direccion: "Carretera de Torrijos - La Puebla de Montalbán, km. 9,1, 45517, Escalonilla (Toledo)",
      posicionImagen: "izquierda"
    },
    {
      id: 2,
      nombre: "QUESERÍA ARTESANAL DEVAS GOURMET",
      sector: "Productos Lácteos",
      descripcion: "ELABORACIÓN DE QUESOS ARTESANOS TRADICIONALES, GOURMET Y DE AUTOR",
      imagen: devasImage,
      email: "contacto@devasgourmet.com",
      telefono: "610015352",
      web: "www.devasgourmet.es",
      direccion: "Calle Castilla la Mancha, 2 PI las Minas ESCALONILLA - TOLEDO",
      posicionImagen: "derecha"
    },
    {
      id: 3,
      nombre: "Hnos. López Navarro, S.L.",
      sector: "Servicios",
      descripcion: "Carpintería de PVC y Aluminio",
      imagen: lopezImage,
      email: "presupuestos@grupoln.es",
      telefono: "660091964",
      web: "https://www.hermanoslopeznavarro.es/",
      direccion: "C/ Albacete 5-7 - 45517 Escalonilla (Toledo)",
      posicionImagen: "izquierda"
    },
    {
      id: 4,
      nombre: "Embutidos La Soledad, S.L.",
      sector: "Alimentario",
      descripcion: "Fábrica de embutidos curados.",
      imagen: soledadImage,
      email: "info@embutidoslasoledad.com",
      telefono: "925758234",
      web: "www.embutidoslasoledad.com",
      direccion: "Calle Puebla, 33-35",
      posicionImagen: "derecha"
    },
    {
      id: 5,
      nombre: "PROYECTOS BORADRI, S.L.",
      sector: "Metal",
      descripcion: "Carpintería de aluminio y PVC",
      imagen: boradriImage,
      email: "aluminiosboradri@gmail.com",
      telefono: "687418511",
      web: "",
      direccion: "Avda. Castilla La Mancha, 14",
      posicionImagen: "izquierda"
    },
    {
      id: 6,
      nombre: "DELPICAS CUADROS ELÉCTRICOS SL",
      sector: "Todos los sectores industriales",
      descripcion: "Fabricación de cuadros eléctricos y automatización industrial, ofreciendo soluciones a medida para el control y distribución de energía.",
      imagen: delpicasImage,
      email: "cdelarosa@delpicas.com",
      telefono: "639118338",
      web: "www.delpicas.com",
      direccion: "Calle Ciudad Real, 9",
      posicionImagen: "derecha"
    },
    {
      id: 7,
      nombre: "COOPERATIVA EL NAZARENO,S.C.L",
      sector: "Fabricación y venta de piensos compuestos",
      descripcion: "Fabricación y venta de piensos compuestos",
      imagen: nazarenoImage,
      email: "administracion@elnazarenoscl.com",
      telefono: "925 75 82 70 / 695 18 30 99",
      web: "",
      direccion: "Crta Torrijos -La Puebla de M Km 26",
      posicionImagen: "izquierda"
    }
  ];

  return (
    <div className="empresas-container">
      <div className="container">
        <h1>Empresas Locales de Escalonilla</h1>
        <p>Conoce las empresas que forman el tejido económico de nuestro municipio, contribuyendo al desarrollo local con productos y servicios de calidad.</p>

        {empresas.map((empresa, index) => (
          <div key={empresa.id} className={`empresa-card ${empresa.id === 5 ? 'boradri-special' : ''} ${empresa.id === 7 ? 'nazareno-special' : ''}`}>
            <div className="empresa-card-body">
              <div className="empresa-nombre">
                <FaIndustry className="empresa-icon" />
                {empresa.nombre}
              </div>
              
              <div className={`empresa-row ${empresa.posicionImagen === 'derecha' ? 'imagen-derecha' : 'imagen-izquierda'}`}>
                {empresa.posicionImagen === 'izquierda' && (
                  <div className="empresa-image-container">
                    <img 
                      src={empresa.imagen} 
                      alt={empresa.nombre}
                      className="empresa-image"
                    />
                  </div>
                )}
                
                <div className="empresa-info">
                  <div className="empresa-sector">
                    <span className="sector-badge">{empresa.sector}</span>
                  </div>

                  <div className="empresa-descripcion">
                    {empresa.descripcion}
                  </div>

                  <div className="empresa-contacto">
                    <h3>Información de Contacto</h3>
                    {empresa.email && (
                      <div className="contacto-item">
                        <FaEnvelope className="contacto-icon" />
                        <a href={`mailto:${empresa.email}`}>{empresa.email}</a>
                      </div>
                    )}
                  
                    {empresa.telefono && (
                      <div className="contacto-item">
                        <FaPhone className="contacto-icon" />
                        <a href={`tel:${empresa.telefono}`}>{empresa.telefono}</a>
                      </div>
                    )}
                    
                    {empresa.web && (
                      <div className="contacto-item">
                        <FaGlobe className="contacto-icon" />
                        <a href={`https://${empresa.web.replace('https://', '')}`} target="_blank" rel="noopener noreferrer">
                          {empresa.web.replace('https://', '')}
                        </a>
                      </div>
                    )}
                    
                    {empresa.direccion && (
                      <div className="contacto-item">
                        <FaMapMarkerAlt className="contacto-icon" />
                        <a 
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(empresa.direccion)}`}
                          target="_blank" 
                          rel="noopener noreferrer"
                        >
                          {empresa.direccion}
                        </a>
                      </div>
                    )}
                  </div>
                </div>

                {empresa.posicionImagen === 'derecha' && (
                  <div className="empresa-image-container">
                    <img 
                      src={empresa.imagen} 
                      alt={empresa.nombre}
                      className="empresa-image"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}

        <div className="contact-info">
          <h3>Apoyo Empresarial</h3>
          <p>
            Desde el Ayuntamiento de Escalonilla apoyamos el desarrollo 
            empresarial local. Si necesitas información sobre estas empresas 
            o estás interesado en establecer tu negocio en nuestro municipio, 
            no dudes en contactarnos.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmpresasLocales;
